import { Routes } from '@angular/router';
import { DeauthGuard } from './guards/deauth-guard/deauth.guard';
import { AdminAuthGuard } from './guards/admin/admin-auth.guard';
import { UserAuthGuard } from './guards/user/user-auth.guard';
import { ForgotPasswordComponent } from './pages/authentication-page/forgot-password/forgot-password.component';
import { OgUserloginComponent } from './pages/authentication-page/og-userlogin/og-userlogin.component';
import { OgAdminloginComponent } from './pages/authentication-page/og-adminlogin/og-adminlogin.component';
import { OghelpComponent } from './pages/common-module/oghelp/oghelp.component';
import { ScriptLoaderService } from 'angular-google-charts';
import { NotfoundComponent } from './pages/common-module/notfound/notfound.component';
import { DashboardUserComponent } from './pages/dashboard-user/dashboard-user.component';
import { FaqComponent } from './pages/common-module/faq/faq.component';
import { UnsubscribeComponent } from './pages/authentication-page/unsubscribe/unsubscribe.component';


export const appRoutes: Routes = [{
  path: 'adminlogin',
  component: OgAdminloginComponent,
  canActivate: [DeauthGuard]
}, {
  path: 'userlogin',
  component: OgUserloginComponent,
  canActivate: [DeauthGuard]
},
{
  path: 'oghelp',
  component: OghelpComponent
},
{
  path: 'faq',
  data: {
    breadcrumb: 'FAQ'
  },
  component: FaqComponent
},
{
  path: 'dashboard',
  data: {
    breadcrumb: 'Dashboard'
  },
  loadChildren: () => import('./pages/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
  canActivate: [AdminAuthGuard],
  providers: [ScriptLoaderService]
}, {
  path: 'home',
  data: {
    breadcrumb: 'Home'
  },
  loadChildren: () => import('./pages/home/home.routes').then((m) => m.HOME_ROUTES),
  canActivate: [UserAuthGuard]
},
{
  path: '404',
  component: NotfoundComponent
}, {
  path: '',
  redirectTo: 'userlogin',
  pathMatch: 'full'
},

{
  path: 'resetPassword',
  component: ForgotPasswordComponent
},
{
  path: 'dashboard-user',
  component: DashboardUserComponent,
  canActivate: [UserAuthGuard]
},
{
  path: 'unsubscribe',
  component: UnsubscribeComponent
},
{
  path: '**',
  redirectTo: '404'
}, {
  path: '403',
  component: NotfoundComponent
},

];

